{
  "menu": {
    "home": "الرئيسية",
    "programs": "البرامج",
    "residency": "الإقامة",
    "citizenship": "جواز السفر والجنسية",
    "about": "من نحن",
    "aboutShort": "عنّا",
    "partnership": "الشركاء",
    "education": "التعليم",
    "news": "رؤى",
    "contact": "تواصل"
  },
  "footer": {
    "copyright": "© 2026 Pacific Link International. All rights reserved.",
    "abn": "Australia · ABN 99 673 671 184",
    "quickLinks": "روابط سريعة",
    "immigrationSite": "برامج الهجرة",
    "educationSite": "برامج الدرجات عبر الإنترنت",
    "legal": "معلومات قانونية",
    "legalNotice": "إشعار قانوني",
    "privacyPolicy": "سياسة الخصوصية",
    "termsOfUse": "شروط الاستخدام"
  }
}
